export default function dayToString(date) {
    let day = (date.getDay()) == 1 ? 'Lunes' : (date.getDay()) == 2 ? 'Martes' : (date.getDay()) == 3 ? 'Miercoles' : (date.getDay()) == 4 ? 'Jueves'
      : (date.getDay()) == 5 ? 'Viernes' : (date.getDay()) == 6 ? 'Sabado' : 'Domingo'

    return day
  }